module.exports = "//static.hsappstatic.net/marketplace-ui-solutions-core/static-1.11813/img/gold-tier-icon.svg"